import { render, staticRenderFns } from "./SubscriptionRulesUpdate.vue?vue&type=template&id=65c6f7bb"
import script from "./SubscriptionRulesUpdate.vue?vue&type=script&lang=js"
export * from "./SubscriptionRulesUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports